import { getCourseCompletionAll } from "@/api";
import { useUser } from "@/providers/context/useUser";
import { useQuery } from "react-query";

export const useCourseCompletionAll = () => {
  const { uid } = useUser();
  const { data, isLoading, error } = useQuery({
    queryKey: ["course-completion-all", uid],
    queryFn: () => getCourseCompletionAll({ userID: uid ?? "" }),
    enabled: !!uid,
    staleTime: 60 * 60 * 1000, // long cache time because its user specific, 1 hour
  });
  return { data, isLoading, error };
};
